export const toTitleCase = (text) => {
  return text
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const formatPhoneNumber = (phoneNumber) => {
  const areaCode = phoneNumber.slice(0, 3);
  const middle = phoneNumber.slice(3, 6);
  const last = phoneNumber.slice(6);
  return `(${areaCode}) ${middle}-${last}`;
};
